import React from "react";
import { FiSearch } from 'react-icons/fi';

function Home() {
    return (
        <div className="container dashboard-home p-2 p-lg-5">
            <div className="position-relative">
                <input type="text" className="search-input" placeholder="البحث بواسطة اسم الجامعة" />
                <FiSearch className="search-icon" color="rgb(50,157,135)" size="2rem" />
            </div>
            <div className="d-flex flex-wrap">
                <div className="dashboard-home__box m-2 dashboard-home__grey p-4">
                    <img className="mb-2" src="/icons/university-black.png" alt="universities" width="auto" height="55" />
                    <h3>الجامعات</h3>
                    <h2>44</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green1 p-4">
                    <img className="mb-2" src="/icons/bus.png" alt="buses" width="auto" height="55" />
                    <h3>الباصات</h3>
                    <h2>3242</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__purple p-4">
                    <img className="mb-2" src="/icons/supervisor.png" alt="supervisors" width="auto" height="55" />
                    <h3>المشرفون</h3>
                    <h2>22</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green2 p-4">
                    <img className="mb-2" src="/icons/supervisor-news.png" alt="news supervisors" width="auto" height="55" />
                    <h3>مشرفو الأخبار</h3>
                    <h2>39</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green1 p-4">
                    <img className="mb-2" src="/icons/news.png" alt="news" width="auto" height="55" />
                    <h4>المنشورات الإخبارية</h4>
                    <h2>5940</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green2 p-4">
                    <img className="mb-2" src="/icons/student.png" alt="students" width="auto" height="55" />
                    <h3>الطلبة</h3>
                    <h2>94380</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green1 p-4">
                    <img className="mb-2" src="/icons/driver.png" alt="drivers" width="auto" height="55" />
                    <h3>السائقون</h3>
                    <h2>5434</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__grey p-4">
                    <img className="mb-2" src="/icons/bus-line.png" alt="bus lines" width="auto" height="55" />
                    <h3>الخطوط</h3>
                    <h2>4353</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__green1 p-4">
                    <img className="mb-2" src="/icons/bus-stop.png" alt="bus stops" width="auto" height="55" />
                    <h3>نقاط التوقف</h3>
                    <h2>8005</h2>
                </div>
                <div className="dashboard-home__box m-2 dashboard-home__purple p-4">
                    <img className="mb-2" src="/icons/bus-stop.png" alt="bus stops" width="auto" height="55" />
                    <h3>ضباط الارتباط</h3>
                    <h2>3404</h2>
                </div>
            </div>
        </div>
    )
}

export default Home